module.exports = __webpack_public_path__ + "images/category_lp/common/reason1-man-50_3e395635dd9768ba118111ef858641f5.jpg";